export const DATE_FORMAT = "DD.MM.YYYY";

export const LIMITS_OPTIONS = [
  { label: "Бессрочно", value: "forever" },
  { label: "Дата окончания", value: "end_date" },
  { label: "Кол-во повторений", value: "repeat_count" },
];

export const FREQUENCY_OPTIONS = [
  { label: "По дням", value: "daily" },
  { label: "По неделям", value: "weekly" },
  { label: "По месяцам", value: "monthly" },
  { label: "По годам", value: "yearly" },
];

export const WEEKS_OPTIONS = [
  { label: "Пн", value: "monday" },
  { label: "Вт", value: "tuesday" },
  { label: "Ср", value: "wednesday" },
  { label: "Чт", value: "thursday" },
  { label: "Пт", value: "friday" },
  { label: "Сб", value: "saturday" },
  { label: "Вс", value: "sunday" },
];

export const PLURALIZATION_WORDS = {
  DAYS: ["день", "дня", "дней"],
  WORK_DAYS: ["рабочий", "рабочих", "рабочих"],
  WEEKS: ["неделю", "недели", "недель"],
  YEARS: ["год", "года", "лет"],
  REPEATS: ["повторения", "повторений", "повторений"],
};

// const START_NEXT_OPTIONS = [
//   {
//     label: "По истечении срока исполнения текущей задачи",
//     value: "after_due_date",
//   },
//   { label: "После завершения текущей задачи", value: "after_completion" },
//   {
//     label: "За определённое кол-во дней до текущей даты",
//     value: "day_before_start_new",
//   },
//   {
//     label: "За определённое кол-во дней до даты окончания текущей задачи",
//     value: "day_before_due_date",
//   },
// ];
